import { useCallback } from 'react';
import { Flex, Typography } from '@banhala/ui-kit';
import type { HeadlineXsmallOneLineCompactProps } from './types';
import { isNil, isNotNil } from '../../../../utils';
import { ViewAllButton } from '../ViewAllButton';
import { useOpenDeeplink } from '../../../../hooks';
import { useLogAnalyticsEvent } from '../../../../hooks/useLogAnalyticsEvent';

export const HeadlineXsmallOneLineCompact = ({
  header,
}: HeadlineXsmallOneLineCompactProps) => {
  const { openDeeplink } = useOpenDeeplink();
  const logAnalyticsEvent = useLogAnalyticsEvent();

  const handlePressMore = useCallback(() => {
    if (isNil(header) || isNil(header.item.deeplink)) return;
    logAnalyticsEvent({
      name: 'CLICK_HEADLINE_XSMALL_ONE_LINE_COMPACT_MORE',
      analytics: header.logging.analytics,
      ably_only_log: header.logging.ably_only_log,
    });
    openDeeplink(header.item.deeplink);
  }, [header, openDeeplink, logAnalyticsEvent]);

  if (isNil(header)) return null;

  const hasDeeplink = isNotNil(header.item.deeplink);

  return (
    <Flex.Row
      padding={{ top: 16, bottom: 8, left: 16, right: hasDeeplink ? 0 : 16 }}
      alignItems="center"
    >
      <Flex flex={1}>
        <Typography type="subtitle1" color="content_primary" numberOfLines={1}>
          {header.item.title}
        </Typography>
      </Flex>
      {hasDeeplink && (
        <Flex padding={{ right: 4 }}>
          <ViewAllButton onPress={handlePressMore} />
        </Flex>
      )}
    </Flex.Row>
  );
};
